import { ContentDelivery } from '@episerver/spa-core';
import Link from '../../../../Components/Shared/Link/link';

type LinkType = {
    href: string;
    text: string;
};

type MenuItemLinkProps = {
    links: ContentDelivery.LinkListProperty;
    handleOnClick: () => void;
};

export const MenuItem = ({ links, handleOnClick }: MenuItemLinkProps) => {
    if (!links?.value || links?.value?.length === 0) {
        return null;
    }

    const linkList: LinkType[] = links.value.map((link: ContentDelivery.LinkProperty) => ({
        href: link.href,
        text: link.text || link.title,
    }));

    const [mainLink, ...subLinks] = linkList;

    return (
        <li>
            <Link className="main-link" onClick={handleOnClick} href={mainLink.href}>
                {mainLink.text}
            </Link>
            {subLinks.length > 0 && (
                <ul className="tu-link-section">
                    {subLinks.map((link, index) => (
                        <li key={`${link.href}-${index}`}>
                            <Link className="secondary-link" onClick={handleOnClick} href={link.href}>
                                {link.text}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default MenuItem;
